import React from "react";
import { motion } from "framer-motion";
import { COMPANY, buildWhatsAppLink } from "@/data/site";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.114.553 4.177 1.6 5.998L4 29l8.2-1.55a11.9 11.9 0 0 0 3.803.62h.001C22.62 28.07 28 22.688 28 16.068 28 9.447 22.623 3 16.003 3Zm0 21.86h-.001a9.9 9.9 0 0 1-3.79-.75l-.272-.11-4.868.92.93-4.745-.177-.29a9.85 9.85 0 0 1-1.51-5.257c0-5.49 4.47-9.958 9.96-9.958 2.66 0 5.16 1.037 7.04 2.92a9.9 9.9 0 0 1 2.916 7.045c0 5.49-4.47 9.958-9.958 9.958Zm5.46-7.46c-.3-.15-1.77-.873-2.045-.973-.274-.1-.474-.15-.673.15-.2.3-.773.973-.948 1.173-.174.2-.35.224-.648.075-.3-.15-1.263-.466-2.406-1.485-.89-.793-1.49-1.774-1.665-2.074-.174-.3-.019-.462.13-.611.134-.134.3-.35.45-.524.15-.175.2-.3.3-.5.1-.2.05-.374-.025-.524-.075-.15-.673-1.622-.923-2.222-.243-.583-.49-.504-.673-.513l-.573-.01c-.2 0-.524.075-.798.375-.274.3-1.048 1.024-1.048 2.496 0 1.472 1.073 2.895 1.222 3.095.15.2 2.11 3.222 5.11 4.516.714.308 1.27.492 1.704.63.716.228 1.368.196 1.884.119.574-.086 1.77-.723 2.02-1.422.25-.699.25-1.298.175-1.423-.074-.124-.273-.2-.573-.349Z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const href = buildWhatsAppLink({
    service: "eine Reinigung",
    message: "Ich hätte gern ein unverbindliches Angebot.",
  });
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp Angebot anfragen"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="pulse-ring fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-[var(--kilic-green)] px-4 py-4 text-white shadow-2xl shadow-green-700/30 md:px-5"
    >
      <WhatsAppIcon className="h-7 w-7" />
      <span className="hidden pr-1 font-bold md:inline">Angebot per WhatsApp</span>
    </motion.a>
  );
};

export { WhatsAppIcon };
